import { endpoints } from '@/modules/jobs/constants';
import type { ApiQueryParameters } from '@/types/utils/parameters';

type JobsQueryParamsApi = ApiQueryParameters<typeof endpoints.jobs>;

export const jobsQueryKeys = {
  all: ['jobs'] as const,
  lists: () => [...jobsQueryKeys.all, 'list'] as const,
  list: (params?: JobsQueryParamsApi) =>
    [...jobsQueryKeys.lists(), 'full', params] as const,
  infiniteList: (params?: JobsQueryParamsApi) =>
    [...jobsQueryKeys.lists(), 'infinite', params] as const,
  detail: (jobId: string) => [...jobsQueryKeys.all, 'detail', jobId] as const,
  inbound: (jobId: string) =>
    [...jobsQueryKeys.detail(jobId), 'inbound'] as const,
  sourcingAllowance: (jobId: string) =>
    [...jobsQueryKeys.detail(jobId), 'sourcingAllowance'] as const,
  notes: (jobId: string) => [...jobsQueryKeys.all, jobId, 'notes'] as const,
  note: (jobId: string, noteId: string) =>
    [...jobsQueryKeys.all, jobId, 'notes', noteId] as const,
};
